const faArrowLeft = {
  prefix: 'fal',
  iconName: 'arrow-left',
  icon: [
    512,
    512,
    [8592],
    'f060',
    'M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z',
  ],
};
export default faArrowLeft;
